import React, {useEffect, useState} from "react";
import pattern from "./PatternInterruption.module.scss";
import {blankImage} from "../../ProductSeries/Image";

const defaultImage = "https://cdn.connox.de/media/gutscheine/Geschenkgutscheine/2018/ExponeaPatternInterruption/geschenkgutschein_birthday@2x.jpg";

/**
 * Pattern Interruption container
 * default is 'Geschenkgutschein'
 * will be alternated by exponea
 * @constructor
 */
const PatternInterruption: React.FC = () => {
  const [src, setSrc] = useState<string>(blankImage);
  const [loadedClass, setLoadedClass] = useState<string | undefined>();

  useEffect(() => {
    setSrc(defaultImage);
  }, []);

  const onLoad = () => {
    setLoadedClass(pattern.loaded);
  };

  const onError = () => {
    setSrc(blankImage);
  };

  return (
    <div className={pattern.interruption}>
      <div className={pattern.image}>
        <img
          alt="Verschenken, was wirklich gefällt &ndash; Gutscheine zum Ausdrucken für verschiedene Anlässe."
          src={src}
          onError={onError}
          onLoad={onLoad}
          className={loadedClass}
        />
      </div>
      <div className={pattern.content}>
        <span className={pattern.headline}>Connox Geschenkgutscheine</span>
        <p>Verschenken, was wirklich gefällt &ndash; Gutscheine zum Ausdrucken für verschiedene Anlässe.</p>
        <a className="button" href="https://www.connox.de/kategorien/geschenk-gutschein.html">
          Jetzt entdecken
        </a>
      </div>
    </div>
  );
};

export default PatternInterruption;
